/* Shared catalog parameter contract. Reads native Shopify options, including
 * Importify imports. No variant membership, prices, credentials or network writes. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.FrezyCatalogParameters = api;
})(typeof globalThis === 'object' ? globalThis : this, function () {
  'use strict';
  const VERSION = 2;
  const SCHEMA = 'cylinder-drills';
  const CHAMFER_SCHEMA = 'chamfer-tools';
  const PCB_SCHEMA = 'pcb-drills';
  const STEP_SCHEMA = 'step-drills';
  const TAPER_SCHEMA = 'taper-drills';
  const NS = 'frezy_catalog';
  const KEY = 'parameters_v2';
  const number = value => {
    if (value === null || value === undefined || value === '') return null;
    const n = Number(String(value).replace(',', '.'));
    return Number.isFinite(n) && n > 0 ? n : null;
  };
  const text = value => String(value || '').replace(/\u00a0/g, ' ').trim();
  const numeric = '\\d+(?:[.,]\\d+)?';
  const material = value => {
    const m = text(value).toUpperCase().match(/(?:^|[^A-Z\d])(M42|M35|M2|6542|4241|4341|9341)(?![A-Z\d])/);
    return m ? m[1] : null;
  };
  function execution(value) {
    const s = text(value).toLowerCase();
    if (/двосторон|двусторон|double.?end|双头/.test(s)) return 'double';
    if (/звужен|зменшен.*хвост|уменьшен.*хвост|reduced.?shank|缩柄/.test(s)) return 'reduced';
    if (/подовжен|удлин|extended|long.?series|加长/.test(s)) return 'extended';
    return null;
  }
  function readDrillOptions(variant, defaults = {}) {
    const options = variant.selectedOptions || variant.optionValues?.map(o => ({ name: o.optionName, value: o.name })) || [];
    const joined = options.map(o => text(o.value)).join(' / ');
    const out = {};
    const ownMaterial = material(joined); if (ownMaterial) out.material = ownMaterial;
    const ownExecution = execution(joined); if (ownExecution) out.execution = ownExecution;
    const kind = /набір|набор|assort|set\b|套装|套钻/i.test(joined) ? 'set' : 'single';
    out.kind = kind;
    const qty = joined.match(/(\d+)\s*(?:шт\.?|pcs?\b|pieces?\b|支|只|个|根)/i);
    if (qty && Number(qty[1]) > 0) out.pack_quantity = Number(qty[1]);
    if (kind === 'set') {
      const range = joined.match(new RegExp('('+numeric+')\\s*[–—-]\\s*('+numeric+')\\s*(?:mm|мм)', 'i'));
      if (range) out.range = range[1].replace('.', ',') + '–' + range[2].replace('.', ',') + ' мм';
      out.diameter_mm = null;
      return out;
    }
    for (const option of options) {
      const name = text(option.name).toLowerCase(); const value = text(option.value);
      if (/кількіст|количеств|quantity|pack.?size|数量/.test(name)) {
        const m = value.match(/^\s*(\d+)\s*(?:шт\.?|pcs?|支|只|个|根)?\s*$/i);
        if (m && Number(m[1]) > 0) out.pack_quantity = Number(m[1]);
      } else if (/довжин|длин|overall|total.?length|全长|总长/.test(name)) {
        const m = value.match(new RegExp(numeric)); if (m) out.overall_length_mm = number(m[0]);
      } else if (/діаметр|диаметр|diameter|直径/.test(name)) {
        const m = value.match(new RegExp(numeric)); if (m) out.diameter_mm = number(m[0]);
      }
    }
    if (out.diameter_mm == null && options.length) {
      const first = text(options[0].value);
      const m = first.match(new RegExp('(?:Ø|φ|Φ)?\\s*('+numeric+')\\s*(?:mm|мм)', 'i'));
      if (m) out.diameter_mm = number(m[1]);
    }
    if ((out.execution || defaults.execution) === 'extended') {
      const pair = joined.match(new RegExp('('+numeric+')\\s*[×xх*]\\s*('+numeric+')\\s*(?:mm|мм)', 'i'));
      if (pair) { out.diameter_mm = number(pair[1]); out.overall_length_mm = number(pair[2]); }
    }
    const explicitLength = joined.match(new RegExp('(?:overall|total\\s*length|全长|总长)\\s*[:=]?\\s*('+numeric+')\\s*(?:mm|мм)', 'i'));
    if (explicitLength) out.overall_length_mm = number(explicitLength[1]);
    return out;
  }
  function safeAttributes(value) {
    const out = {};
    for (const [key, v] of Object.entries(value || {})) {
      if (['diameter_mm', 'overall_length_mm', 'working_length_mm', 'shank_diameter_mm', 'morse_taper', 'included_angle_deg', 'chamfer_angle_deg', 'hole_min_mm', 'hole_max_mm', 'flutes', 'adjustment_max_deg', 'step_min_mm', 'step_max_mm', 'step_count'].includes(key)) {
        const n = number(v); if (n !== null) out[key] = n;
      } else if (key === 'pack_quantity') {
        const n = number(v); if (Number.isInteger(n)) out[key] = n;
      } else if (['material', 'execution', 'kind', 'range', 'tool_type', 'component', 'coating', 'holder_series', 'diameter_display', 'shank_display', 'series', 'flute', 'case_included'].includes(key) && typeof v === 'string' && v.length <= 120) out[key] = v;
    }
    return out;
  }
  // Opt-in exact reviewed source facts. Never parse or infer legacy defaults here.
  const REVIEWED_STEP_CONTRACT = 'reviewed-step-variants/1';
  const stepOwn = (o, k) => Object.prototype.hasOwnProperty.call(o, k);
  const stepObject = o => o !== null && typeof o === 'object' && !Array.isArray(o);
  const stepKeys = (o, keys) => stepObject(o) && Object.keys(o).length === keys.length && keys.every(k => stepOwn(o,k));
  const stepPositive = n => typeof n === 'number' && Number.isFinite(n) && n > 0 && n < 10000;
  function reviewedStepOptions(options) {
    return Array.isArray(options) && options.length === 1 && options.every(o => stepKeys(o,['name','value']) && typeof o.name === 'string' && o.name.length > 0 && o.name.length <= 120 && typeof o.value === 'string' && o.value.length > 0 && o.value.length <= 240);
  }
  function reviewedStepAttributes(a) {
    const required = ['tool_type','kind','series','flute','pack_quantity','step_min_mm','step_max_mm','range'];
    const optional = ['step_count','shank_diameter_mm','overall_length_mm','case_included'];
    if (!stepObject(a) || !required.every(k=>stepOwn(a,k)) || Object.keys(a).some(k=>!required.includes(k)&&!optional.includes(k))) return false;
    if (a.tool_type !== 'step' || !['single','set'].includes(a.kind) || !['M35','TIAIN','4241','6542'].includes(a.series) || !['straight','spiral'].includes(a.flute)) return false;
    if (!stepPositive(a.step_min_mm) || !stepPositive(a.step_max_mm) || a.step_max_mm <= a.step_min_mm || a.pack_quantity !== (a.kind === 'set' ? 3 : 1)) return false;
    if (a.kind === 'single' ? !Number.isInteger(a.step_count) || a.step_count < 2 || a.step_count > 1000 : stepOwn(a,'step_count')) return false;
    if (['shank_diameter_mm','overall_length_mm'].some(k=>stepOwn(a,k)&&!stepPositive(a[k]))) return false;
    if (stepOwn(a,'case_included') && !['yes','no'].includes(a.case_included)) return false;
    if (typeof a.range !== 'string' || a.range.length > 240) return false;
    const chunks = a.range.replace(/ мм$/, '').split(' / ');
    if (!a.range.endsWith(' мм') || chunks.length !== a.pack_quantity) return false;
    const pairs = chunks.map(s=>s.match(/^(\d+(?:,\d+)?)–(\d+(?:,\d+)?)$/)).map(m=>m ? [Number(m[1].replace(',','.')),Number(m[2].replace(',','.'))] : null);
    return !pairs.some(p=>!p||!stepPositive(p[0])||p[1]<=p[0]) && Math.min(...pairs.map(p=>p[0]))===a.step_min_mm && Math.max(...pairs.map(p=>p[1]))===a.step_max_mm;
  }
  function reviewedStepDocument(facts) {
    if (!stepKeys(facts,['version','schema','variant_contract','skus']) || facts.version !== 2 || facts.schema !== STEP_SCHEMA || facts.variant_contract !== REVIEWED_STEP_CONTRACT || !stepObject(facts.skus)) return false;
    const entries = Object.entries(facts.skus);
    return entries.length > 0 && entries.length <= 250 && entries.every(([sku,row])=>/^[A-Za-z0-9_-]{1,128}$/.test(sku) && stepKeys(row,['match','attributes']) && stepKeys(row.match,['selectedOptions']) && stepKeys(row.match.selectedOptions,['uk','ru']) && ['uk','ru'].every(locale=>reviewedStepOptions(row.match.selectedOptions[locale])) && reviewedStepAttributes(row.attributes));
  }
  function readReviewedStepVariant(variant,facts) {
    if (!reviewedStepDocument(facts) || typeof variant.sku !== 'string' || !stepOwn(facts.skus,variant.sku) || !reviewedStepOptions(variant.selectedOptions)) return {};
    const row=facts.skus[variant.sku];
    const same = expected=>expected.length===variant.selectedOptions.length && expected.every((o,i)=>o.name===variant.selectedOptions[i].name&&o.value===variant.selectedOptions[i].value);
    return ['uk','ru'].some(locale=>same(row.match.selectedOptions[locale])) ? { ...row.attributes } : {};
  }
  function validateReviewedStepVariants(variants,facts) {
    if (!reviewedStepDocument(facts) || !Array.isArray(variants) || variants.length !== Object.keys(facts.skus).length || new Set(variants.map(v=>v.sku)).size !== variants.length) return false;
    return variants.every(v=>readReviewedStepVariant(v,facts).tool_type==='step');
  }
  function derive(variant, facts = {}) {
    if (stepOwn(facts,'variant_contract')) return readReviewedStepVariant(variant,facts);
    const defaults = safeAttributes(facts.attributes);
    const parsed = facts.schema === SCHEMA ? readDrillOptions(variant, defaults) : facts.schema === CHAMFER_SCHEMA ? readChamferOptions(variant, facts) : facts.schema === PCB_SCHEMA ? readPcbOptions(variant) : facts.schema === STEP_SCHEMA ? readStepOptions(variant) : facts.schema === TAPER_SCHEMA ? readTaperOptions(variant) : {};
    // Unknown imported options must not inherit a previously selected steel family.
    if ([STEP_SCHEMA, TAPER_SCHEMA].includes(facts.schema) && !parsed.kind) return {};
    const extra = facts.skus?.[String(variant.sku || '')];
    const identity = { ...defaults, ...parsed };
    const matches = extra && Object.entries(extra.match || {}).every(([key, value]) => identity[key] === value);
    return { ...defaults, ...(matches ? safeAttributes(extra.attributes) : {}), ...parsed };
  }
  function familyAttributes(title, description, schema = SCHEMA) {
    if (schema === CHAMFER_SCHEMA) return chamferFamily(title, description);
    if (schema === PCB_SCHEMA) return /твердосплав|carbide/i.test(text(title)) ? { material: 'carbide', tool_type: 'pcb' } : {};
    if (schema === STEP_SCHEMA) return stepFamily(title);
    if (schema === TAPER_SCHEMA) return taperFamily(title);
    if (schema !== SCHEMA) return {};
    const attributes = {};
    const grade = material(title); if (grade) attributes.material = grade;
    const kind = execution(title);
    if (kind) attributes.execution = kind;
    else if (/звичайні|обычные|standard|jobber|普通/i.test(title)) attributes.execution = 'standard';
    if (/ц[іе]на\s+(?:вказана\s+)?за\s*1\s*(?:свердло|сверло|шт)|price\s+(?:is\s+)?per\s+(?:1|one)\s*(?:drill|piece)/i.test(text(description).replace(/<[^>]*>/g, ' '))) attributes.pack_quantity = 1;
    // A fixed series length is explicit catalog data, not a DIN assumption.
    if (attributes.execution === 'extended') {
      const length = text(title).match(/(?:,\s*|×\s*|x\s*)(200|300|400|500)\s*мм\s*$/i);
      if (length) attributes.overall_length_mm = Number(length[1]);
    }
    return attributes;
  }
  function stepFamily(value) {
    const s = text(value);
    if (/TiAlN|TIAIN/i.test(s)) return { series: 'TiAlN', coating: 'TiAlN', material: null, tool_type: 'step' };
    if (/Co5|M35/i.test(s)) return { series: 'Co5', material: 'M35', coating: null, tool_type: 'step' };
    if (/6542|\bM2\b/i.test(s)) return { series: 'HSS6542', material: '6542', coating: null, tool_type: 'step' };
    if (/4241/i.test(s)) return { series: 'HSS4241', material: '4241', coating: null, tool_type: 'step' };
    return {};
  }
  function taperFamily(value) {
    const s = text(value), grade = material(s);
    return { tool_type: 'taper-drill', execution: /подовжен|удлин|extended/i.test(s) ? 'extended' : 'standard',
      ...(/Co5|M35/i.test(s) ? { material: 'M35' } : grade ? { material: grade } : /HSS/i.test(s) ? { material: 'HSS' } : {}) };
  }
  function readTaperOptions(variant) {
    // Diameter, total length and Morse number are independent facts. Never infer
    // a taper or working length from the diameter or a standards table.
    const options = variant.selectedOptions || variant.optionValues?.map(o => ({ name: o.optionName, value: o.name })) || [];
    if (options.length === 1) {
      const s = text(options[0].value);
      const m = s.match(new RegExp('^(?:Ø|φ|Φ)?\\s*('+numeric+')(?:\\s*[×xх*]\\s*('+numeric+'))?\\s*(?:мм|mm)(?:\\s*·\\s*(?:КМ|MT)\\s*([1-6]))?$', 'i'));
      return m ? { kind: 'single', diameter_mm: number(m[1]), ...(m[2] ? { overall_length_mm: number(m[2]) } : {}), ...(m[3] ? { morse_taper: Number(m[3]) } : {}) } : {};
    }
    const out = {};
    for (const option of options) {
      const name = text(option.name), s = text(option.value);
      const m = s.match(new RegExp('^(?:Ø)?\\s*('+numeric+')\\s*(?:мм|mm)?$', 'i'));
      if (m && /діаметр|диаметр|diameter/i.test(name)) out.diameter_mm = number(m[1]);
      if (m && /загальна довжина|общая длина|overall length/i.test(name)) out.overall_length_mm = number(m[1]);
      const mt = s.match(/^(?:КМ|MT)?\s*([1-6])$/i);
      if (mt && /морзе|morse/i.test(name)) out.morse_taper = Number(mt[1]);
    }
    return out.diameter_mm == null ? {} : { kind: 'single', ...out };
  }
  function readStepOptions(variant) {
    const options = variant.selectedOptions || variant.optionValues?.map(o => ({ name: o.optionName, value: o.name })) || [];
    if (options.length !== 1) return {};
    const s = text(options[0].value), fmt = n => String(n).replace('.', ',');
    const fluteNames = '(Пряма канавка|Прямая канавка|Спіральна канавка|Спиральная канавка)';
    const native = s.match(new RegExp('^'+fluteNames+'\\s*·\\s*('+numeric+')[–-]('+numeric+')\\s*мм\\s*·\\s*(\\d+)\\s*ступ\\.\\s*·\\s*1\\s*шт\\.$', 'i'));
    if (native) {
      const lo = number(native[2]), hi = number(native[3]), count = Number(native[4]);
      if (lo == null || hi <= lo || count < 2) return {};
      return { tool_type: 'step', kind: 'single', flute: /сп[іи]раль/i.test(native[1]) ? 'spiral' : 'straight', step_min_mm: lo, step_max_mm: hi, range: fmt(lo)+'–'+fmt(hi)+' мм', step_count: count, pack_quantity: 1 };
    }
    const set = s.match(new RegExp('^(?:(У чохлі|В чехле)\\s*·\\s*)?'+fluteNames+'\\s*·\\s*(?:набір|набор)\\s*3\\s*шт\\.\\s*\\(([^)]+)\\)$', 'i'));
    if (set) {
      const parts = set[3].replace(/\s*мм\s*$/i, '').split('/').map(p => p.trim().match(new RegExp('^('+numeric+')[–-]('+numeric+')$')));
      if (parts.length !== 3 || parts.some(p => !p || number(p[1]) == null || number(p[2]) <= number(p[1]))) return {};
      const pairs = parts.map(p => [number(p[1]), number(p[2])]);
      return { tool_type: 'step', kind: 'set', flute: /сп[іи]раль/i.test(set[2]) ? 'spiral' : 'straight', pack_quantity: 3, case_included: set[1] ? 'yes' : 'no', range: pairs.map(p=>fmt(p[0])+'–'+fmt(p[1])).join(' / ')+' мм', step_min_mm: Math.min(...pairs.map(p=>p[0])), step_max_mm: Math.max(...pairs.map(p=>p[1])) };
    }
    // Native import labels identify material explicitly. No dimensions are taken
    // from the shop-wide length/shank fields or borrowed from a neighbouring SKU.
    const family = stepFamily(s); if (!family.series) return {};
    const bag = /布袋套装/.test(s), importedSet = /三件套/.test(s) || bag;
    if (importedSet) return { ...family, kind: 'set', flute: /螺旋/.test(s) ? 'spiral' : 'straight', case_included: bag ? 'yes' : 'no', ...(!bag ? { pack_quantity: 3 } : {}) };
    const pair = s.match(new RegExp('('+numeric+')-('+numeric+')', 'i'));
    const cn = { '十五': 15, '十一': 11, '十': 10, '九': 9, '五': 5 };
    const step = s.match(/(\d+|十五|十一|十|九|五)阶/);
    if (!pair || !step || number(pair[1]) == null || number(pair[2]) <= number(pair[1])) return {};
    const lo = number(pair[1]), hi = number(pair[2]), count = cn[step[1]] || Number(step[1]);
    return { ...family, kind: 'single', flute: /螺旋/.test(s) || family.series === 'TiAlN' ? 'spiral' : 'straight', step_min_mm: lo, step_max_mm: hi, range: fmt(lo)+'–'+fmt(hi)+' мм', step_count: count, pack_quantity: 1 };
  }
  function readPcbOptions(variant) {
    // PCB packs contain one fixed diameter; an assortment range is never a
    // cutting diameter. Only complete, explicit option grammars are accepted.
    const options = variant.selectedOptions || variant.optionValues?.map(o => ({ name: o.optionName, value: o.name })) || [];
    if (options.length !== 1) return {};
    const s = text(options[0].value);
    const fmt = v => String(number(v)).replace('.', ',');
    const normalizedSet = s.match(new RegExp('^(?:Набір|Набор|Assortment)\\s*[ØφΦ]?\\s*('+numeric+')\\s*[–—-]\\s*('+numeric+')\\s*(?:мм|mm)\\s*[·,;]?\\s*(\\d+)\\s*(?:шт\\.?|pcs?\\.?)$', 'i'));
    const importedSet = s.match(new RegExp('^('+numeric+')\\s*[–—-]\\s*('+numeric+')\\s*mm\\s*十支组合套装$', 'i'));
    const legacySet = s.match(new RegExp('^(?:Набір|Набор)\\s*[ØφΦ]?\\s*('+numeric+')\\s*[–—-]\\s*('+numeric+')\\s*мм$', 'i'));
    const set = normalizedSet || importedSet || legacySet;
    if (set) {
      const lo = number(set[1]), hi = number(set[2]);
      const qty = importedSet ? 10 : legacySet ? null : Number(set[3]);
      return lo != null && hi > lo && (qty == null || qty > 1)
        ? { kind: 'set', diameter_mm: null, range: fmt(lo)+'–'+fmt(hi)+' мм', ...(qty == null ? {} : { pack_quantity: qty }) } : {};
    }
    const normalizedPack = s.match(new RegExp('^(?:Упаковка|Pack)\\s*[ØφΦ]?\\s*('+numeric+')\\s*(?:мм|mm)\\s*[·,;]?\\s*(\\d+)\\s*(?:шт\\.?|pcs?\\.?)$', 'i'));
    const importedPack = s.match(new RegExp('^('+numeric+')\\s*mm\\s*\\(\\s*(\\d+)支装\\s*\\)$', 'i'));
    const pack = normalizedPack || importedPack;
    if (!pack || number(pack[1]) == null || !Number.isInteger(Number(pack[2])) || Number(pack[2]) < 1) return {};
    return { kind: 'single', diameter_mm: number(pack[1]), pack_quantity: Number(pack[2]) };
  }
  function chamferFamily(title, description) {
    const s = text(title); const a = { component: 'tool' };
    if (/PCD/i.test(s)) { a.tool_type = 'pcd'; a.material = 'PCD'; }
    else if (/дерев|wood|V-подіб|V-образ/i.test(s)) { a.tool_type = 'wood'; a.material = 'carbide'; a.chamfer_angle_deg = 45; }
    else if (/регульован|регулируем|adjustable/i.test(s)) { a.tool_type = 'adjustable';const angle=s.match(/0\s*[–-]\s*(\d+)\s*°/);if(angle)a.adjustment_max_deg=number(angle[1]); }
    else if (/змінн.*пласт|сменн.*пласт|індекс|индекс|indexable/i.test(s)) { a.tool_type = 'indexable'; a.component = 'body'; }
    else if (/центру|центр[ои]|spot/i.test(s)) { a.tool_type = 'spot'; if (/твердосплав|carbide/i.test(s)) a.material = 'carbide'; }
    else if (/зенк|countersink/i.test(s)) a.tool_type = 'countersink';
    const co5 = /(?:Co5|M35)/i.test(s), m2 = /\bM2\b/i.test(s);
    if (co5 && !m2) a.material = 'M35'; else if (m2 && !co5) a.material = 'M2';
    if (['spot','countersink'].includes(a.tool_type) && /90\s*°/.test(s)) a.included_angle_deg = 90;
    if (/TiAlN/i.test(s)) a.coating = 'TiAlN';
    return a;
  }
  function readChamferOptions(variant, facts = {}) {
    const options = variant.selectedOptions || []; const s = options.map(o => text(o.value)).join(' / '); const a = {};
    const type = facts.attributes?.tool_type;
    if (type === 'adjustable') {
      a.component = /^(?:Тримач|Корпус|Держатель|Holder|Body)(?:\s|$)/i.test(s) ? 'body' : 'insert';
      a.adjustment_max_deg = a.component === 'body' ? facts.attributes?.adjustment_max_deg || (/0\s*[–-]\s*85/.test(facts.evidence?.adjustment || '') ? 85 : null) : null;
    }
    if (type === 'indexable') {
      a.component = 'body'; const code = s.match(/\b([BW]\d{2})\b/i) || s.match(/\b([BW]\d{2})(?=[A-Z])/i);
      if (code) a.holder_series = code[1].toUpperCase();
    }
    const grade = ['spot','countersink'].includes(type) ? material(s) : null;
    if (grade) a.material = grade;
    else if (['spot','countersink'].includes(type) && /(?:^|[^A-Z\d])(?:HSS.?)*Co5(?![A-Z\d])/i.test(s)) a.material = 'M35';
    if (/TiAlN/i.test(s)) a.coating = 'TiAlN';
    else if (/титан|titanium|титанов/i.test(s)) a.coating = 'titanium';
    else if (/без покриття|без покрытия|bright finish/i.test(s)) a.coating = 'uncoated';
    if (type === 'pcd') {
      if (/на замовлення|на заказ|custom/i.test(s)) { a.component = 'custom'; return a; }
      // The supplier's Phi dimension is the shank; D is the cutting head.
      const p = s.match(new RegExp('[ΦφØ]\\s*('+numeric+')\\s*[×xх*]\\s*D\\s*('+numeric+')\\s*[×xх*]\\s*('+numeric+')L\\s*[×xх*]\\s*('+numeric+')\\s*°','i'));
      if (p) { a.shank_diameter_mm=number(p[1]); a.diameter_mm=number(p[2]); a.overall_length_mm=number(p[3]); a.included_angle_deg=number(p[4]); }
      return a;
    }
    if (type === 'wood') {
      const fractions = [...s.matchAll(/(\d+)\s*\/\s*(\d+)\s*[″"]/g)];
      if (fractions.length === 2) { a.diameter_mm=Number(fractions[0][1])/Number(fractions[0][2])*25.4; a.shank_diameter_mm=Number(fractions[1][1])/Number(fractions[1][2])*25.4; a.diameter_display=fractions[0][1]+'/'+fractions[0][2]+'″'; a.shank_display=fractions[1][1]+'/'+fractions[1][2]+'″'; }
      return a;
    }
    if (type === 'spot') {
      const d = s.match(new RegExp('D\\s*('+numeric+')\\s*[×xх*]\\s*D\\s*('+numeric+')\\s*[×xх*]\\s*('+numeric+')','i'));
      const pair = s.match(new RegExp('(?:^|/\\s*)('+numeric+')\\s*[×xх*]\\s*('+numeric+')\\s*(?:мм|mm)','i'));
      if (d) { a.diameter_mm=number(d[1]);a.shank_diameter_mm=number(d[2]);a.overall_length_mm=number(d[3]); }
      else if (pair) { a.diameter_mm=number(pair[1]);a.overall_length_mm=number(pair[2]); }
    }
    for (const option of options) {
      const name=text(option.name); const value=text(option.value);
      if (/канав|кром|flutes?/i.test(name)) { const f=value.match(/\b([1-9])\b/);if(f)a.flutes=Number(f[1]); }
      if (!['spot','countersink'].includes(type)) continue;
      // Hole capacity is distinct from cutting-head diameter. Sets may contain
      // adjacent capacity ranges; never fill an unoffered gap between tools.
      if (/зенкування|зенкования|отв[оі]р|hole/i.test(name)) {
        const capacities = [...value.matchAll(new RegExp('('+numeric+')\\s*[–—-]\\s*('+numeric+')', 'g'))].map(m => [number(m[1]),number(m[2])]);
        const qty = value.match(/(\d+)\s*(?:шт\.?|pcs?\b|pieces?\b)/i);
        const remainder = value.replace(new RegExp('('+numeric+')\\s*[–—-]\\s*('+numeric+')', 'g'), '').replace(/\d+\s*(?:шт\.?|pcs?\b|pieces?\b)|набір|набор|set\b|мм|mm|[\s+·,;/()]/gi, '');
        if (capacities.length && !remainder && capacities.every(([lo,hi]) => lo != null && hi > lo)) {
          if (qty) { a.pack_quantity=Number(qty[1]);a.kind=Number(qty[1])>1?'set':'single'; }
          const sorted=capacities.slice().sort((x,y)=>x[0]-y[0]);
          if (sorted.every((r,i)=>i===0 || r[0]<=sorted[i-1][1])) {a.hole_min_mm=sorted[0][0];a.hole_max_mm=Math.max(...sorted.map(r=>r[1]));}
          else {a.hole_min_mm=null;a.hole_max_mm=null;}
          a.range=capacities.map(([lo,hi])=>lo+'–'+hi).join(' + ')+' мм';
        }
      }
      if (/діаметр|диаметр|розмір|размер|diameter|size/i.test(name)) {
        const single=value.match(new RegExp('^(?:Ø|φ|Φ)?\\s*('+numeric+')\\s*(?:мм|mm)(?:\\s*\\(\\s*1\\s*шт\\.?\\s*\\))?\\s*$','i'));
        const range=value.match(new RegExp('^('+numeric+')\\s*[–—-]\\s*('+numeric+')\\s*(?:мм|mm)$','i'));
        if(single)a.diameter_mm=number(single[1]);
        // Only an explicit hole-range option denotes through-hole capacity.
        if(range && /зенкування|зенкования|отв[оі]р|hole/i.test(name)){a.hole_min_mm=number(range[1]);a.hole_max_mm=number(range[2]);}
      }
    }
    if (a.component === 'body') { const c=s.match(/\bC(\d+(?:[.,]\d+)?)/i);if(c)a.shank_diameter_mm=number(c[1]); }
    return a;
  }
  return { VERSION, SCHEMA, CHAMFER_SCHEMA, PCB_SCHEMA, STEP_SCHEMA, TAPER_SCHEMA, NS, KEY, derive, readDrillOptions, readChamferOptions, readPcbOptions, readStepOptions, readTaperOptions, familyAttributes, safeAttributes, readReviewedStepVariant, validateReviewedStepVariants };
});
